/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespNullSearchResultsHeader_searchBrowse = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResultsHeader_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_searchBrowse",
      "args": null
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
